<template>
    <div class="h-100" style="padding-bottom: 14px;">
        <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
            
            <filters-top-bar 
            v-bind="currentDownloadReportProperties"
            @changeSelectedReportComponent="changeSelectedReportComponent"
            filterReportContext="jobs">
            </filters-top-bar>

            <button-top-bar title="Generate Report"
             v-on:click.native="downloadjobsReportData()">
            </button-top-bar>
        </div>
        <div class="last-synced-date-time-wrapper">
            <span class="last-synced-date-time-label">{{$t('Last Synced at')}}: </span>
            <span class="last-synced-date-time-value" v-if="lastSyncedDateTime" :title="getDateAndTimeInConfiguredFormat(lastSyncedDateTime)">{{getDateAndTimeInConfiguredFormat(lastSyncedDateTime)}}</span>
        </div>
        <div class="jobs-report-div" style="margin-top: 16px;">
            <table v-if="jobsReportData && jobsReportData.length > 0" class="table table-with-border table-scroll small-first-col"  style="background: transparent;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 30%;padding-inline-start: 0px !important;" class="text-left">{{$t('Slugname')}}</th>
                        <th style="width: 10%;padding-inline-start: 0px !important;" class="text-left">{{$t('Job name')}}</th>
                        <th style="width: 16%" class="">{{$t('Status')}}</th>
                        <th style="width: 16%" class="text-center">{{$t('DateTime')}}</th>
                        <th style="width: 13%;">{{$t('Username')}}</th>
                        <th style="width: 15%;padding-inline-start: 8px !important;" class="text-left">{{$t('Node Id')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="jobObj in jobsReportData"
                        :key="jobObj._id"
                        class="ccomm-logs-row" :class="{activeclass: activeIndex === jobObj._id}">

                        <td class="text-left" style="position:relative;padding-inline-end: 10px !important;">
                            <span v-if="Object.keys(jobObj).includes('resource_name') && jobObj.resource_name.length > 0" class="text-ellipsis" :title="jobObj.resource_name">{{ jobObj.resource_name }}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td>

                        <td class="text-left" style="position:relative;">
                            <span v-if="Object.keys(jobObj).includes('job_name') && jobObj.job_name.length > 0" :title="jobObj.job_name" class="text-ellipsis">{{ jobObj.job_name }}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td>

                        <td class="text-left" style="position:relative;">
                            <!-- <span v-if="Object.keys(jobObj).includes('state') && jobObj.state.length > 0" :title="jobObj.state" class="text-ellipsis">{{ jobObj.state }}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span> -->
                            <div class="d-flex">
                                <div v-if="jobObj.state == 'COMPLETED'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                    </svg>
                                </div>
                                <div v-if="jobObj.state == 'FAILED' || jobObj.state == 'ABORTED'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                    </svg>
                                </div>
                                <div v-if="jobObj.state == 'QUEUED'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-clock-fill" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                    </svg>
                                </div>
                                <div v-if="jobObj.state == 'IN_PROGRESS'" style="display:inline-flex;width:96%">
                                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                    </svg> -->
                                    <div class="progress">
                                    <div :id="jobObj.job_id" class="progress-bar" role="progressbar" :style="{'width':jobObj.status_info.progress+'%'}" :aria-valuenow="jobObj.status_info.progress" aria-valuemin="0" aria-valuemax="100">{{parseInt(jobObj.status_info.progress) + "%"}}</div>
                                    </div>
                                    <div v-if="jobObj.status_info && jobObj.status_info.bandwidth" style="font-size:11px;width:35%">{{humanizeBandwidth(jobObj.status_info.bandwidth).bandwidth}} {{humanizeBandwidth(jobObj.status_info.bandwidth).unit}}</div>
                                </div>
                                <span class="ml-2" v-if="jobObj.state != 'IN_PROGRESS'">{{jobObj.state}}</span>
                                </div>
                        </td>

                        <td class="text-center">
                            <!-- <span v-if="Object.keys(jobObj).includes('created_datetime') && jobObj.created_datetime.length > 0">{{formatedDate(jobObj.created_datetime)}}</span> -->
                            <span v-if="Object.keys(jobObj).includes('created_datetime') && jobObj.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(jobObj.created_datetime)">{{checkIsTodayoryesterdayDate(jobObj.created_datetime)?getDateAndTimeInConfiguredFormat(jobObj.created_datetime, true) : getDateAndTimeInConfiguredFormat(jobObj.created_datetime)}}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td>

                        <!-- <td class="text-center">
                            <span v-if="Object.keys(jobObj).includes('size') && jobObj.size != null && jobObj.size != undefined">{{getConvertedFileSize(jobObj.size)}}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td> -->

                        <td class="text-left" style="position:relative;">
                            <span v-if="Object.keys(jobObj).includes('user_id') && jobObj.user_id.length > 0" :title="getUserNameFromId(jobObj.user_id)" class="text-ellipsis">{{ getUserNameFromId(jobObj.user_id) }}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td>

                        <!-- <td class="text-center">
                            <span v-if="Object.keys(jobObj).includes('data') && jobObj.data.duration">{{getHumanReadableDuration(jobObj.data.duration)}}</span>
                            <span v-else> - </span>
                        </td> -->

                        <td style="position:relative;padding-inline-start: 9px !important;">
                            <span v-if="Object.keys(jobObj).includes('node_id') && jobObj.node_id.length > 0" :title="jobObj.node_id" style="word-break: break-all;">{{jobObj.node_id}}</span>
                            <span v-else class="validationmessage">{{$t('No Data found')}}</span>
                        </td>

                    </tr>
                </tbody>
            </table> 
            <div v-else class="dull-the-text" style="display: flex;justify-content: center;align-items: center;font-size: 20px;height:100%">
                {{$t('No Data Found')}}
            </div> 
        </div>  
        <div>
            <pagination
                v-model="page"
                :records="totalJobs"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />    
        </div>         
    </div>
</template>   

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    import Pagination from "vue-pagination-2";
    // import DatePicker from "vue2-datepicker";
    // import "vue2-datepicker/index.css";
    // import Multiselect from 'vue-multiselect';
    import FiltersTopbar from "./filtersBar.vue";
    import {NotifierConstants} from "../../components.constants.js";
    export default {
        data(){
                return{
                    page: 1,
                    totalPages: -1,
                    totalJobs: -1,
                    perPage: -1,
                    jobsReportData:[],
                    jobsUserMap:[],
                    userNameIdMap:{},
                    time1:null,
                    selectedUserInfo:{},
                    selectedUserGroupInfo:{},
                    filterBy:{},
                    userListFromAutocomplete:[],
                    userGroupListFromAutocomplete:[],
                    searchByUser:"",
                    showUserFilter:false,
                    showUserGroupFilter:false,
                    searchByGroup:"",
                    fileNameFilter:"",
                    // filterByAction:{
                    //     state:"All",
                    //     job_name:"All"
                    // },
                    options:{chunk:5},
                    selectedJobName:"All",
                    searchKey :"",

                    payloadParams : {},
                    activeIndex:null,
                    lastSyncedDateTime:null
                } 
        },  
        components:{
            // 'k-progress': KProgress,
            pagination: Pagination,
            "button-top-bar":buttonsTopbar,
            "filters-top-bar":FiltersTopbar,
        },
        methods:{
            changeSelectedReportComponent(filtersdata){
                if('action' in filtersdata ){
                   filtersdata['job_name'] = filtersdata['action'];
                   delete filtersdata['action']; 
                }

                if('file_name' in filtersdata){
                    filtersdata['resource_name'] = filtersdata['file_name'].trim();
                    delete filtersdata['file_name'];
                }
                this.$nextTick(()=>{
                    this.payloadParams = filtersdata;
                    this.refreshJobsReport(false);
                });    
            },
            refreshJobsReport(isPageClick = false) {
                // this.showUserFilter = false
                // this.showUserGroupFilter = false
                let payload = {}
                // let paramsInfo = {}
                if(isPageClick){
                     this.payloadParams.page = this.page
                }
                
                // if(typeof this.selectedUserInfo != "undefined"){
                //     let userIdList = [];
                //     userIdList.push(this.selectedUserInfo._id);
                //     paramsInfo.user_id = this.userIdList
                // }
                // if(typeof this.selectedUserGroupInfo != "undefined"){
                //     paramsInfo.group_id = this.selectedUserGroupInfo._id
                // }
                // if(typeof this.time1 != "undefined" &&
                // this.time1 != null && this.time1.length == 2 && this.time1[0] != null){
                //     paramsInfo.from_date = this.time1[0]+"T00:00:00"
                //     paramsInfo.to_date = this.time1[1]+"T00:00:00"
                // }
                // if(typeof this.fileNameFilter != "undefined" && this.fileNameFilter.trim().length > 0){
                //     paramsInfo["file_name"] = this.fileNameFilter
                //     paramsInfo.filter=JSON.stringify(["file_name"])
                // }

                // if(typeof this.filterByAction != "undefined" && (this.filterByAction.job_name.trim() <= 0 || this.filterByAction.job_name.trim() != "All")){
                //     paramsInfo["action"] = this.filterByAction.job_name;
                // }
                // payload.params = paramsInfo

                payload.params = this.payloadParams;
                payload.isPrivExists = this.isPrivilegeExists('reports');
                this.getJobsReportFromServer(payload).then((data) => {
                    this.totalPages = data["page_count"];
                    // this.page = data["page"];
                    this.totalJobs = data["total_jobs_report"];
                    this.perPage = data["jobs_report_per_page"];
                    this.jobsReportData = data.jobs;
                    this.jobsUserMap = data.user_map;
                    this.lastSyncedDateTime = data.last_run_at;
                    this.userListFromAutocomplete = []
                    this.userGroupListFromAutocomplete = []
                }); 
            },
            isPrivilegeExists(privilegeName){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), privilegeName);
            },

            downloadjobsReportData() {
                // let filePath = url;
                let payload = {};
                payload.params =this.payloadParams;

                if('action' in payload.params ){
                   payload.params['job_name'] = payload.params['action'];
                   delete payload.params['action']; 
                }

                if('file_name' in payload.params){
                    payload.params['resource_name'] = payload.params['file_name'].trim();
                    delete payload.params['file_name'];
                }

                this.$toast.info("You will be notified once the report is ready to download");
                payload.isPrivExists = this.isPrivilegeExists('reports'); 
                this.downloadjobsReportFromServer(payload).then(() => {
                    console.log("Downloading report")
                // const blob = new Blob([response.data], {
                //     type: "application/vnd.csv",
                // });
                // const link = document.createElement("a");
                // link.href = URL.createObjectURL(blob);
                // link.setAttribute(
                //     "download",
                //     response.headers["content-disposition"].split("filename=")[1]
                // );
                // document.body.appendChild(link);
                // link.click();
                })
                .catch(console.error);
            },

            getHumanReadableDuration(duration){
                return Utils.getDurationInSeconds(duration)
            },

            // getConvertedFileSize(size){
            //     return Utils.getConvertedFileSize(size);
            // },  

            // ...mapActions("JobsReports", ["getStorageReportFromServer"]),
            getusersOnKeyup(option){
                this.showUserFilter = true
                this.showUserGroupFilter = false
                let payload = {}
                // if(typeof(option) != "undefined" && option.trim().length > 0){
                if(typeof(option) != "undefined" && option.length > 0){  
                    payload.params = {username:option}
                    this.getUsersAutoComplitionFromServerIngest(payload).then((data) => {
                        this.userGroupListFromAutocomplete = [];
                        this.userListFromAutocomplete = data["users"];
                    });
                }else if(option.length==0){
                    // this.updateUsersList(false);
                    // this.filterBy.user_id = "";
                    // this.updateJobsListFromServer(false,true, option);
                    // this.userListFromAutocomplete = this.usersList;
                    // delete this.selectedUserInfo._id;
                    // this.refreshAuditLogs(false)
                    this.getAllUsersFromServerIngest(payload).then((data) => {
                        this.userListFromAutocomplete = data.users;
                    });
                }
            },

            hideUsersDropdown(){
                if(this.userListFromAutocomplete.length > 0 && this.searchByUser.length==0){
                    this.userListFromAutocomplete = [];
                }
            },
            selectionLabelCallback(option){
                return `${option.username}`
            },
            updateUsersFilter(option){
                this.selectedUserInfo["_id"] = option._id;
                this.searchKey = option.username;
                this.refreshAuditLogs(false);
            },
            getUserGroupsOnKeyup(){
                this.showUserGroupFilter = true
                this.showUserFilter = false
                let payload = {};
                payload.params = {user_id: this.selectedUserID};
                this.getAllUserGroupsFromServer(payload).then((data)=>{
                    this.userGroupListFromAutocomplete = data.user_groups;
                });
            },

            getConvertedFileSize(size){
                return Utils.getConvertedFileSize(size);
            }, 

            formatedDate(date){
                return Utils.getDateTimeFormat(date);
            },
            getUserNameFromId(userId){
                let username = ""
                if(this.jobsUserMap.length > 0){
                    let usermap = this.jobsUserMap.filter((usersMap)=>(usersMap.user_id == userId))
                    if(usermap != undefined &&  typeof usermap != "undefined" && usermap[0]!= undefined){
                      
                        username = usermap[0].username
                    }
                }
                return username
            },

            paginate() {
                // this.page = page;
                this.refreshJobsReport(true);
            },
            handleIngestNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    this.refreshJobsReport(false)
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:[NotifierConstants.fileCreatedNotification],
                    callback:this.handleIngestNotification,
                    parent: "JobsReports"})
            },
            unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:[NotifierConstants.fileCreatedNotification],
                    callback:this.handleIngestNotification,
                    parent: "JobsReports"})
            },

            ...mapActions("jobsReports", ["getJobsReportFromServer", "downloadjobsReportFromServer"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        created(){
            this.searchByUser = this.getLoggedInUser()
            this.selectedUserInfo._id= this.getLoggedInUserId();
            this.showUserFilter = false;
            let loggedInUserIdList = [];
            loggedInUserIdList.push(this.selectedUserInfo._id);
            this.payloadParams["user_id"] = JSON.stringify(loggedInUserIdList);
            this.refreshJobsReport(false);
            this.registerforWebsocketNotifications()
        },
        computed: {
            currentDownloadReportProperties() {
                return { reportContext : "jobs"};
            },
        },
    }
</script>

<style scoped lang="scss">
     $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

    .text-ellipsis{
        white-space: nowrap; 
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis; 
        display: block;
        position: absolute;
    }

    .jobs-report-div{
        padding: 0px 30px 10px 30px;
        height: calc(100% - 135px);
        overflow: auto;
    }

    th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }

    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .activeclass {
        color: $active-blue;
    }
    .ccomm-logs-row:hover {
        .jobs-info-icon{
            visibility:visible;
        }
    }

    .ccomm-logs-row:hover{
        color: $active-blue;
    }
    .table-with-border {
        thead {
            border-bottom: none;
        }
        tr {
            border-bottom: none;
        }
    }
    
    .table{
        color:#fff !important;
        th{
            border-top:none !important;
            padding: 1rem 0px !important;
        }
        td{
            border-top:none !important;
            padding: 0px !important;
            padding-inline-start: 2px !important;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
            height:60px;
            }
        }
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            position: absolute;
            top: 12%;
            inset-inline-start:5%;
            height: 38px !important;
            padding-inline-start: 8%;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }
    }

    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs div{
        display:inline-flex;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color !important;
            }
        }
    }

    li {
      width: 25%;
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .progress{
        width:100%;
        height:14px;
        background: #292929;
        margin-inline-end:3px;
    }

    .last-synced-date-time-wrapper{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-inline-end: 12px;
        margin-top: 10px;
        .last-synced-date-time-label{
            color: $dull-text-color;
            text-align: end;
        }
        .last-synced-date-time-value{
            color: $learn-about-text-color;
            margin-inline-start: 4px;
            display:grid;
        }
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    ::v-deep {
         .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    position: relative;
    margin-inline-start: 5px;
    top: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
}    

/* width */
::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }
.dull-the-text{
    color: $secondary-text-color;
  }

</style>